<template>
  <div class="card h-100">
    <p class="title px-3 py-3 mb-0 custom-title">
      <!-- <img
        v-if="iconPath"
        class="icon-img"
        src="@/assets/Images/icons/flat-color-icons-services.png"
        alt=""
      /> -->
      {{ cardTitle }}
    </p>
    <div class="card-body p-0">
      <div v-if="cardData.length === 0" class="loader" style="height: 100%">
        <EmptyData />
      </div>
      <div
        v-for="item in listItems"
        :key="item.name"
        @click="itemClicked('/' + urlDashboard + '/' + item.additional, item.name, item.source)"
        class="list-items py-3 px-3 d-flex justify-content-between"
      >
        <div class="list-item">{{ item.name }}</div>
        <div class="list-items-number fw-b">{{ item.number }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { dashboardStore } from '@/stores/dashboard'
import router from '@/router'
import EmptyData from '@/components/utilities/elements/emptyData.vue'
export default {
  name: 'AppCard',
  components: {
    EmptyData
  },
  props: {
    cardTitle: String,
    cardIconName: String,
    cardData: Array,
    routing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      listData: null
    }
  },
  computed: {
    ...mapState(authStore, ['dashboardName']),
    urlDashboard() {
      let _url = 'service-details'
      if (this.dashboardName) {
        _url = this.dashboardName
      }
      return _url
    },
    listItems() {
      let _data = []
      if (this.cardData) {
        _data = this.cardData
      }
      return _data
    }
  },
  methods: {
    ...mapActions(dashboardStore, ['setFirm']),
    itemClicked(event, name, source) {
      let firmId = event.split('/')
      let firm = firmId[firmId.length - 1]
      this.setFirm({
        firm: firm,
        name: name,
        source: source
      })
      console.log('Set Firm:', {
        firm: firm,
        name: name,
        source: source
      })
      if (this.routing === 'true') {
        router.push(event)
      }
    }
  }
}
</script>
<style scoped>
.card {
  box-shadow: 0 6px 12px 0 rgba(57, 99, 93, 0.05);
  border-radius: 10px;
  overflow: hidden;
}
.custom-title {
  background-color: rgb(244, 249, 247);
}
.icon-img {
  max-width: 15px;
  margin-right: 8px;
}
.card-body {
  max-height: 410px;
  height: 100%;
  overflow-y: scroll;
}
.main-card .card-body {
  max-height: 100%;
  overflow: initial;
}
.title {
  font-size: 1.1em;
  font-weight: 600;
  border-bottom: 1px solid var(--bs-border-color-translucent);
}
.list-items {
  border-bottom: 1px solid var(--bs-border-color-translucent);
}
.list-items:nth-child(even) {
  background-color: var(--cs-card-background);
}
.list-items:hover {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.05);
}
@media (max-width: 767px) {
  .main-card .card-body,
  .card-body {
    max-height: 260px;
    overflow-y: scroll;
  }
}
</style>
